export default __webpack_public_path__ + "static/media/xploration_capital_preview.png";